import { VIBE_ATTR_PATH } from '../constants/api';
import {
  EULA_CONFIRMATION,
  EULA_GANDALF_PROFILE_FIELD,
} from '../constants/auth';
import { UPDATE_EULA } from '../constants/metrics';
import { AppConfig } from '../types/app';
import { GandalfUser } from '../types/auth';
import { profileRequest } from '../utils/apiHelper';
import { v4 as uuidv4 } from 'uuid';

export function isEulaAccepted(
  user: GandalfUser,
  consentAccepted: boolean | undefined
) {
  //This checks EULA on token and also check if EULA will be handled as part of Combined EULA workflow
  return (
    Boolean(user.eulaStatus?.toLowerCase() === EULA_CONFIRMATION) ||
    consentAccepted === true
  );
}

export async function acceptEula(config: AppConfig, user: GandalfUser) {
  if (!user.jwtToken) {
    throw new Error('User token not defined');
  }

  const opts: RequestInit = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: user.jwtToken,
      'X-Correlation-ID': uuidv4(),
    },
    body: JSON.stringify({
      attributes: [
        {
          name: EULA_GANDALF_PROFILE_FIELD,
          attributeValue: {
            S: EULA_CONFIRMATION,
          },
        },
      ],
    }),
  };

  const resp = await profileRequest(config, VIBE_ATTR_PATH, opts, {
    logWithRum: true,
    metricNs: UPDATE_EULA,
  });

  return resp.json();
}
